// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__X8DER","HeroMainTextWrapper":"Hero_HeroMainTextWrapper__coTCk","HeroMainText":"Hero_HeroMainText__VSKAW","HeroDescriptionText":"Hero_HeroDescriptionText__QRv4z"};